import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
  direction: 'left' | 'right';
  disabled: boolean;
  onClick: () => void;
}

/**
 * Prev / next carousel button — hover-revealed on desktop, hidden when disabled
 * (at the ends). Sits inside the carousel's `relative` wrapper.
 */
export function ScrollButton({ direction, disabled, onClick }: Props) {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      onClick={event => {
        event.stopPropagation();
        onClick();
      }}
      disabled={disabled}
      aria-label={direction === 'left' ? 'Previous slide' : 'Next slide'}
      className={`bg-scrim/55 hover:bg-scrim/70 absolute top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full text-white shadow transition disabled:opacity-0 ${
        direction === 'left' ? 'left-2' : 'right-2'
      }`}
    >
      <Icon className="h-5 w-5" aria-hidden />
    </button>
  );
}
